import * as yup from 'yup'

export const editProductSchema = yup.object({
  new_product_name: yup.string().required('Product name is a required.'),
  // category: yup.object().required('Category is required'),
  // brand: yup.object().required('Brand is required'),
})
